var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.27593 4.55806C9.52 4.80214 9.52 5.19786 9.27593 5.44194L5.34287 9.375H17.1673C17.5125 9.375 17.7923 9.65482 17.7923 10C17.7923 10.3452 17.5125 10.625 17.1673 10.625H5.34287L9.27593 14.5581C9.52 14.8021 9.52 15.1979 9.27593 15.4419C9.03185 15.686 8.63612 15.686 8.39204 15.4419L3.39204 10.4419C3.14796 10.1979 3.14796 9.80214 3.39204 9.55806L8.39204 4.55806C8.63612 4.31398 9.03185 4.31398 9.27593 4.55806Z",
  fill: "currentColor"
})));
export default SvgArrowLeft;